import React, {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {Button, ChevronLeftIcon} from '@taopix/taopix-design-system';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {PageListSelector} from '../../Selectors';
import {useTaopix} from '../Context/TaopixContext';

const PreviousPageButton = () => {
  const app = useTaopix();
  const ui = useUiState();

  const {t} = useTranslation();

  const pageNumberList = useSelector(PageListSelector);

  const onPreviousPage = useCallback(() => {
    const nextPageNumber = pageNumberList[pageNumberList.indexOf(ui.state.pageNumber) - 1];
    if (undefined === nextPageNumber) {
      return;
    }
    /*
    NOTE: Do not use behaviour 'smooth' on setPage because it triggers browser bugs that prevents
    two project viewers scrolling at the same time (i.e. primary and thumbnails),
    and/or scrolls to the wrong location
    */
    app.core.get('abilities').setPage(nextPageNumber).then();
  }, [ui.state.pageNumber]);

  const disabled = useMemo(() => {
    return pageNumberList.indexOf(ui.state.pageNumber) === 0;
  }, [ui.state.pageNumber]);

  return (
    <Button
      label={t('*:str_ButtonPreviousPage')}
      hideLabel
      id="paginator-left"
      startIcon={<ChevronLeftIcon />}
      buttonStyle={'tertiary'}
      size={'small'}
      onClick={onPreviousPage}
      disabled={disabled}
      className={'absolute ml-lg'}
    />
  );
};

export default PreviousPageButton;
